import React from "react";

const currencies = [
    "INR",
    "USD",
    "EUR",
    "GBP",
    "AUD",
    "CAD",
    "JPY",
    "AED",
    "SGD"
];

const languages = [
    "English",
    "Hindi",
    "Bengali",
    "Spanish",
    "French",
    "German",
    "Japanese",
    "Chinese",
    "Arabic"
];

const timezones = [
    "Asia/Kolkata",
    "UTC",
    "Asia/Dubai",
    "Asia/Singapore",
    "Europe/London",
    "Europe/Paris",
    "America/New_York",
    "America/Los_Angeles",
    "Australia/Sydney"
];

const countries = [
    "India",
    "United States",
    "United Kingdom",
    "Canada",
    "Australia",
    "Germany",
    "France",
    "Japan",
    "Singapore",
    "United Arab Emirates"
];

export default function BrandStep4({

    form,

    updateField

}) {

    return (

        <div>

            <h2
                style={{
                    marginBottom:8
                }}
            >
                Business Preferences
            </h2>

            <p
                style={{
                    color:"#777",
                    marginBottom:30
                }}
            >
                Configure how your business will operate on myFAVV Marketplace.
            </p>

            {/* Currency */}

            <div
                style={{
                    marginBottom:20
                }}
            >

                <label
                    style={{
                        display:"block",
                        marginBottom:8,
                        fontWeight:600
                    }}
                >
                    Default Currency
                </label>

                <select

                    value={form.currency}

                    onChange={(e)=>

                        updateField(
                            "currency",
                            e.target.value
                        )

                    }

                    style={{
                        width:"100%",
                        padding:12,
                        borderRadius:8,
                        border:"1px solid #ddd"
                    }}

                >

                    {currencies.map(currency=>(

                        <option
                            key={currency}
                            value={currency}
                        >
                            {currency}
                        </option>

                    ))}

                </select>

            </div>

            {/* Language */}

            <div
                style={{
                    marginBottom:20
                }}
            >

                <label
                    style={{
                        display:"block",
                        marginBottom:8,
                        fontWeight:600
                    }}
                >
                    Default Language
                </label>

                <select

                    value={form.language}

                    onChange={(e)=>

                        updateField(
                            "language",
                            e.target.value
                        )

                    }

                    style={{
                        width:"100%",
                        padding:12,
                        borderRadius:8,
                        border:"1px solid #ddd"
                    }}

                >

                    {languages.map(language=>(

                        <option
                            key={language}
                            value={language}
                        >
                            {language}
                        </option>

                    ))}

                </select>

            </div>

            {/* Timezone */}

            <div
                style={{
                    marginBottom:20
                }}
            >

                <label
                    style={{
                        display:"block",
                        marginBottom:8,
                        fontWeight:600
                    }}
                >
                    Time Zone
                </label>

                <select

                    value={form.timezone}

                    onChange={(e)=>

                        updateField(
                            "timezone",
                            e.target.value
                        )

                    }

                    style={{
                        width:"100%",
                        padding:12,
                        borderRadius:8,
                        border:"1px solid #ddd"
                    }}

                >

                    {timezones.map(zone=>(

                        <option
                            key={zone}
                            value={zone}
                        >
                            {zone}
                        </option>

                    ))}

                </select>

            </div>

            {/* Country */}

            <div
                style={{
                    marginBottom:20
                }}
            >

                <label
                    style={{
                        display:"block",
                        marginBottom:8,
                        fontWeight:600
                    }}
                >
                    Business Country
                </label>

                <select

                    value={form.country || ""}

                    onChange={(e)=>

                        updateField(
                            "country",
                            e.target.value
                        )

                    }

                    style={{
                        width:"100%",
                        padding:12,
                        borderRadius:8,
                        border:"1px solid #ddd"
                    }}

                >

                    <option value="">
                        Select Country
                    </option>

                    {countries.map(country=>(

                        <option
                            key={country}
                            value={country}
                        >
                            {country}
                        </option>

                    ))}

                </select>

            </div>

            {/* Tax Registration */}

            <div
                style={{
                    marginBottom:20
                }}
            >

                <label
                    style={{
                        display:"block",
                        marginBottom:8,
                        fontWeight:600
                    }}
                >
                    Tax / GST / VAT Number
                </label>

                <input

                    type="text"

                    value={form.taxNumber || ""}

                    onChange={(e)=>

                        updateField(
                            "taxNumber",
                            e.target.value
                        )

                    }

                    placeholder="Optional"

                    style={{
                        width:"100%",
                        padding:12,
                        borderRadius:8,
                        border:"1px solid #ddd"
                    }}

                />

            </div>

            {/* Business Hours */}

            <div
                style={{
                    marginBottom:20
                }}
            >

                <label
                    style={{
                        display:"block",
                        marginBottom:8,
                        fontWeight:600
                    }}
                >
                    Business Hours
                </label>

                <input

                    type="text"

                    value={form.businessHours || ""}

                    onChange={(e)=>

                        updateField(
                            "businessHours",
                            e.target.value
                        )

                    }

                    placeholder="Mon - Fri | 10:00 AM - 7:00 PM"

                    style={{
                        width:"100%",
                        padding:12,
                        borderRadius:8,
                        border:"1px solid #ddd"
                    }}

                />

            </div>

            {/* Notifications */}

            <div
                style={{
                    marginTop:35,
                    padding:20,
                    borderRadius:10,
                    background:"#F8FAFC",
                    border:"1px solid #E2E8F0"
                }}
            >

                <h3
                    style={{
                        marginTop:0
                    }}
                >
                    Notifications
                </h3>

                <label
                    style={{
                        display:"block",
                        marginBottom:10
                    }}
                >

                    <input
                        type="checkbox"
                        checked={form.emailNotifications ?? true}
                        onChange={(e)=>

                            updateField(
                                "emailNotifications",
                                e.target.checked
                            )

                        }
                    />

                    {" "}
                    Email Notifications

                </label>

                <label
                    style={{
                        display:"block",
                        marginBottom:10
                    }}
                >

                    <input
                        type="checkbox"
                        checked={form.smsNotifications ?? false}
                        onChange={(e)=>

                            updateField(
                                "smsNotifications",
                                e.target.checked
                            )

                        }
                    />

                    {" "}
                    SMS Notifications

                </label>

                <label
                    style={{
                        display:"block"
                    }}
                >

                    <input
                        type="checkbox"
                        checked={form.pushNotifications ?? true}
                        onChange={(e)=>

                            updateField(
                                "pushNotifications",
                                e.target.checked
                            )

                        }
                    />

                    {" "}
                    Push Notifications

                </label>

            </div>

        </div>

    );

}